/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_File_HelpInputs */

const en_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a JSON or EDL file containing markers`)
};

const fr_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un fichier JSON ou EDL contenant des marqueurs`)
};

const de_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine JSON- oder EDL-Datei mit Markierungen aus.`)
};

const it_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file JSON o EDL contenente i marcatori`)
};

const ru_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл JSON или EDL, содержащий маркеры.`)
};

const es_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un archivo JSON o EDL que contenga marcadores`)
};

const zh_cn2_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择包含标记的 JSON 或 EDL 文件。`)
};

const ja_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーを含むJSONまたはEDLファイルを選択`)
};

const hi_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर युक्त JSON या EDL फ़ाइल का चयन करें`)
};

const pt_pt2_marker_import_file_help = /** @type {(inputs: Marker_Import_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um arquivo JSON ou EDL contendo marcadores.`)
};

/**
* | output |
* | --- |
* | "Select a JSON or EDL file containing markers" |
*
* @param {Marker_Import_File_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_file_help = /** @type {((inputs?: Marker_Import_File_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_File_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_file_help(inputs)
	if (locale === "de") return de_marker_import_file_help(inputs)
	if (locale === "it") return it_marker_import_file_help(inputs)
	if (locale === "ru") return ru_marker_import_file_help(inputs)
	if (locale === "es") return es_marker_import_file_help(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_file_help(inputs)
	if (locale === "ja") return ja_marker_import_file_help(inputs)
	if (locale === "hi") return hi_marker_import_file_help(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_file_help(inputs)
	return en_marker_import_file_help(inputs)
});